const RECENT_PRODUCTS = 'recent_products_novaporta';

export const getRecentProducts = () => {
    if (!process.client) {
        return [];
    }
    const items = localStorage?.getItem(RECENT_PRODUCTS);
    return items ? JSON.parse(items) : [];
};

export const setRecentProduct = productId => {
    if (!process.client) {
        return [];
    }
    const items = getRecentProducts();
    let newItems = items;

    if (!productId || items.includes(productId)) return;
    else {
        newItems = [productId, ...newItems.filter((_, idx) => idx < 30)];
        localStorage.setItem(RECENT_PRODUCTS, JSON.stringify(newItems));
    }
};

export const isInRecentProducts = productId => {
    return getRecentProducts().includes(productId);
};
